import { RootState } from '../../../store/rootReducer';

export const ContractDetailsContentSelector = (state: RootState) => state.content.contractDetails;
